class AlertBox {
  static render(type, message, target) {
    const html = `<div class="alert alert-box ${type} fade in">
      <p>${message}</p>
      <a class="close" href="#" data-dismiss="alert"></a>
    </div>`;

    target.html($(html));
  }
}

export default AlertBox;
